module.exports = __webpack_public_path__ + "img/farming_51.75c05dc5.png";